// extracted by mini-css-extract-plugin
export default {"flex":"TypeProducts_flex__ak5KO","link":"TypeProducts_link__FqP9d"};